<template>
  <div style="margin: 10px 0; padding: 10px; border: 1px solid #ddd; border-radius: 4px;">
    <div style="font-size: 12px; color: #666; margin-bottom: 8px; display: flex; justify-content: space-between; align-items: center;">
      <span>导出配置：</span>
      <el-button 
          type="text" 
          size="mini" 
          style="color: #999; font-size: 11px; padding: 0 5px;"
          @click="clearExportConfig">
        清除配置
      </el-button>
    </div>
    <div>
      <span>文件名称：</span>
      <el-input
          v-model="txt"
          placeholder="请输入文件名称，如：production_scan"
          size="mini"
          style="width: 280px;"
          @change="saveExportConfig"
      />
    </div>
    <div style="font-size: 11px; color: #999; margin-top: 5px;">
      提示：配置将自动保存到本地，下次访问时自动加载
    </div>
  </div>
</template>
<script>
  export default {
    name: "ExportTxtConfig",
    props: {
      storageKeyPrefix: {
        type: String,
        default: "exportTxt",
      },
      fileName: {
        type: String,
        default: "",
      },
    },
    data() {
      return {
        txt: "",
      };
    },
    watch: {
      // 监听fileName变化，更新txt
      fileName: {
        handler(newVal) {
          if (newVal && newVal !== this.txt) {
            this.txt = newVal;
          }
        },
        immediate: true,
      },
    },
    mounted() {
      // 初始化时从localStorage加载配置
      this.loadExportConfig();
    },
    methods: {
      loadExportConfig() {
        const fileNameKey = `fileName_${this.storageKeyPrefix}`;
        const savedFileName = localStorage.getItem(fileNameKey);
        if (savedFileName) {
          this.txt = savedFileName;
          this.$emit("update:fileName", savedFileName);
        } else if (this.fileName) {
          this.txt = this.fileName;
        }
      },
      saveExportConfig() {
        const fileNameKey = `fileName_${this.storageKeyPrefix}`;
        if (this.txt) {
          localStorage.setItem(fileNameKey, this.txt);
          this.$emit("update:fileName", this.txt);
        }
      },
      clearExportConfig() {
        this.$confirm("确定要清除导出配置吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.txt = "";
          // 清除localStorage中的配置
          const fileNameKey = `fileName_${this.storageKeyPrefix}`;
          localStorage.removeItem(fileNameKey);
          this.$emit("update:fileName", "");
          this.$message.success("导出配置已清除");
        }).catch(() => {
          // 用户取消
        });
      },
    },
  };
</script>